<template>
  <div class="container">
    <div class="banner">
      <img :src="data.banner" alt="">
    </div>
    <div class="box">
      <div class="left">
        <div class="titleNav cursor">首页>{{ data.stitle }}！</div>
        <div class="title">{{ data.title }}</div>
        <div class="time"><span class="icon iconjinlingyingcaiwangtubiao74"></span> {{ data.time }}</div>

        <div class="content" v-html="data.content">
        </div>

        <div class="label">
          <div class="lbox">
            <div class="t">标签</div>
            <div class="a cursor">{{ data.tags }}</div>
          </div>
        </div>

        <div class="pagination">
          <div class="cursor">上一资讯：{{ data.on }}</div>
          <div class="cursor">下一资讯：{{ data.under }}</div>
        </div>

      </div>
      <div class="right">
        <div class="title">新闻推荐</div>
        <div class="boxList">
          <div class="item" v-for="(v,i) in data.list" :key="i">
            <div class="l">
              <img :src="v.src" alt="">
            </div>
            <div class="r">{{ v.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newsCenter",
  data() {
    return {
      newsCenter: {
        entrePriseNews: {
          banner: require('../../assets/home/newsCenter/entrePriseNews.jpg'),
          title: '米果码复工通知',
          stitle: '企业动态>米果码复工通知',
          time: '2021-2-26 09:20:56',
          content: `<p>近日来疫情基本得到控制，人们紧张多时的精神终于可以舒缓一下。国家也开始鼓励企业有序复工复产，正常的生活秩序将会逐步得到恢复。正是春回大地，万物复苏。</p><p>2021携手共进，米果码与企业客户共同期待在新的一年取得更好的成绩！</p><p>四川米果码信息技术有限公司是二维码溯源系统集成一站式服务提供商，提供专业可靠的溯源软件系统、车间改造、赋码设备、采集设备。为食用农产品、食品、药品、农业生产资料、特种设备、危险品、稀土产品等行业订制符合国家政策规定的溯源系统，并结合硬件为企业提供一站式的溯源集成服务。</p><p> 独创C3引擎， 以成熟、 可靠、 易扩展的平台架构及功能组件， 能够快速实现不同行业应用场景的二次开发和功能定制， 带给用户更好的使用体验。目前，米果码服务的企业遍布全国80%以上省份，在不同行业、不同领域、不同场景下提供了全方位的解决方案与服务。 </p> <p>我们致力于“正直诚信、务实高效、创造价值”的经营理念，携手更多的企业走好数字化转型第一步。</p><p>我们的优势：溯源系统集成服务商，一站式服务，提供溯源软件开发，喷码机、采集设备等。行业首家推出“6+1”智能营销解决方案的公司，20个行业、50个细分领域的溯源解决方案，5年互联产品运营经验。</p>`,
          tags: '复工/溯源系统/赋码设备/溯源软件系统/溯源集成服务/营销解决方案/溯源解决方案',
          on: '国务院办公厅关于加快追溯体系建设的意见',
          under: '致技术工程部伙伴的一封感谢信',
          list: [
            {src: require('../../assets/home/ws.png'), text: '在米果码这个大家庭，有这么一批人，为着一个共同的目标，不辞辛苦地奔波着，只为帮助客户解决技术难题...'},
            {src: require('../../assets/home/nd.png'), text: '“正直诚信、务实高效、创造价值”的经营理念，携手更多的企业走好数字化转型第一步'},
            {src: require('../../assets/home/ws.png'), text: '在米果码这个大家庭，有这么一批人，为着一个共同的目标，不辞辛苦地奔波着，只为帮助客户解决技术难题...'},
            {src: require('../../assets/home/nd.png'), text: '“正直诚信、务实高效、创造价值”的经营理念，携手更多的企业走好数字化转型第一步'},
            {src: require('../../assets/home/ws.png'), text: '在米果码这个大家庭，有这么一批人，为着一个共同的目标，不辞辛苦地奔波着，只为帮助客户解决技术难题...'}
          ],

        },
        industryAdvisory: {
          banner: require('../../assets/home/newsCenter/industryAdvisory.jpg'),
          title: '国务院办公厅关于加快追溯体系建设的意见',
          stitle: '企业动态>国务院办公厅关于加快追溯体系建设的意见',
          time: '2021-2-26 09:20:56',
          content: `<p>到2020年，追溯体系建设的规划标准体系得到完善，法规制度进一步健全。 追溯体系建设是采集记录产品生产、流通、消费等环节信息，实现来源可查、去向可追、责任可究，强化全过程质量安全管理与风险控制的有效措施。近年来，各地区和有关部门围绕食用农产品、食品、药品、稀土产品等重要产品，积极推动应用物联网、云计算等现代信息技术建设追溯体系，在提升企业质量管理能力、促进监管方式创新、保障消费安全等方面取得了积极成效。但是，也存在统筹规划滞后、制度标准不健全、推进机制不完善等问题。为加快应用现代信息技术建设重要产品追溯体系，经国务院同意，现提出以下意见：</p><p>一、总体要求</p>　　<p>　　（一）指导思想。贯彻落实党的十八大和十八届二中、三中、四中、五中全会精神，按照国务院决策部署，坚持以落实企业追溯管理责任为基础，以推进信息化追溯为方向，加强统筹规划，健全标准规范，创新推进模式，强化互通共享，加快建设覆盖全国、先进适用的重要产品追溯体系，促进质量安全综合治理，提升产品质量安全与公共安全水平，更好地满足人民群众生活和经济社会发展需要。</p><p>　　（二）基本原则。坚持政府引导与市场化运作相结合，发挥企业主体作用，调动各方面积极性；坚持统筹规划与属地管理相结合，加强指导协调，层层落实责任；坚持形式多样与互联互通相结合，促进开放共享，提高运行效率；坚持政府监管与社会共治相结合，创新治理模式，保障消费安全和公共安全。</p><p>　　（三）主要目标。到2020年，追溯体系建设的规划标准体系得到完善，法规制度进一步健全；全国追溯数据统一共享交换机制基本形成，初步实现有关部门、地区和企业追溯信息互通共享；食用农产品、食品、药品、农业生产资料、特种设备、危险品、稀土产品等重要产品生产经营企业追溯意识显著增强，采用信息技术建设追溯体系的企业比例大幅提高；社会公众对追溯产品的认知度和接受度逐步提升，追溯体系建设市场环境明显改善。</p>`,
          tags: '质量安全/溯源系统/溯源管理/追溯体系/溯源集成服务/追溯体系建设',
          on: '米果码经营理念',
          under: '中华人民共和国农业部公告',
          list: [
            {src: require('../../assets/home/ws.png'), text: '在米果码这个大家庭，有这么一批人，为着一个共同的目标，不辞辛苦地奔波着，只为帮助客户解决技术难题...'},
            {src: require('../../assets/home/nd.png'), text: '“正直诚信、务实高效、创造价值”的经营理念，携手更多的企业走好数字化转型第一步'},
            {src: require('../../assets/home/ws.png'), text: '在米果码这个大家庭，有这么一批人，为着一个共同的目标，不辞辛苦地奔波着，只为帮助客户解决技术难题...'},
            {src: require('../../assets/home/nd.png'), text: '“正直诚信、务实高效、创造价值”的经营理念，携手更多的企业走好数字化转型第一步'},
            {src: require('../../assets/home/ws.png'), text: '在米果码这个大家庭，有这么一批人，为着一个共同的目标，不辞辛苦地奔波着，只为帮助客户解决技术难题...'}
          ],

        },
      },

      data: {},
    }
  },
  created() {
    scroll(0, 0);
    this.data = this.$route.query.id == 1 ? this.newsCenter.entrePriseNews : this.newsCenter.industryAdvisory
  }
}
</script>

<style lang="less" scoped>

.banner {
  height: 500px;

  img {
    width: 100%;
    height: 100%;
  }
}

.box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding-bottom: 112px;
  padding-top: 58px;


  .left {
    width: 60%;

    .titleNav {
      font-family: Microsoft YaHei, serif;
      width: 100%;
      height: 35px;
      font-size: 14px;
      font-weight: 400;
      color: #24439C;
      line-height: 35px;
      padding-left: 10px;
      margin-left: 5px;
      background: #BFBFBF;
      border-radius: 5px;

    }

    .title {
      font-size: 48px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin: 50px 0 30px;
      text-align: left;
    }

    .time {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;

      span {
        font-size: 14px;
        position: relative;
        top: -2px;
      }
    }

    /deep/ .content {
      padding-left: 10px;
      width: 100%;
      //height: 700px;
      padding-bottom: 44px;
      border-bottom: 1px solid #F5F5F5;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      color: #666666;
      text-indent: 30px;

      overflow: hidden;

      p {
        margin: 30px 0 0;
      }

      p:last-child {
        margin-bottom: 0;
      }
    }

    .label {
      padding-left: 10px;
      width: 100%;
      margin: 32px 0 31px;
      padding-bottom: 32px;
      border-bottom: 1px solid #F5F5F5;


      .lbox {
        padding-left: 34px;
        padding-top: 16px;
        height: 95px;
        width: 100%;
        background: #BFBFBF;
        border-radius: 5px;

        .t {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          margin-bottom: 13px;

        }

        .a {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #666666;
        }
      }

    }

    .pagination {
      > div {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #3450A0;
        margin-top: 38px;
      }
    }

  }

  .right {
    width: 35%;
    padding-top: 70px;

    .title {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      border-bottom: 1px solid #F5F5F5;
      padding-bottom: 14px;
    }


    .item {
      margin-top: 20px;
      padding-bottom: 18px;
      border-bottom: 1px solid #F5F5F5;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .l {
        width: 40%;
        height: 118px;

        img {
          width: 100%;
          height: 100%
        }
      }

      .r {
        width: 55%;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        //height: 57px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;

      }

    }

  }

}

</style>







